export const globalComponentsRegister = Vue => {
  const requireComponent = require.context('.', true, /App[\w]+\.vue$/)
  requireComponent
    .keys()
    .map(requireComponent)
    .map(val => val.default)
    .map(comp => Vue.component(comp.name, comp))
}
